export enum CategoryType {
  ACCESSORY = 'akcesoria',
}
